module.exports = {'common.greeting':'Howdy!'}